<template>
  <base-modal :id="tooltipId"
              tabindex="-1"
              size="sm"
              centered
              hide-footer
              hide-header
              no-close-on-backdrop
              no-close-on-esc
              align="center">
    <div class="tooltip-container">
      <b-row v-if="isAlert"
             no-gutters
             align="center"
             class="row--no-wrap">
        <b-col align="center">
          <div class="icon-with-text-wrapper">
            <inline-svg v-if="displayAlertIcon"
                        src="AlertIcon"
                        class="icon--red">
            </inline-svg>
            <h2 :id="`${tooltipId} HeaderText`"
                align="left"
                class="text-red text-300 header-text text-28">
              {{ headerText }}
            </h2>
          </div>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col>
          <h2 class="text-heading header-text text-30">
            {{ headerText }}
          </h2>
        </b-col>
      </b-row>

      <div v-if="headerDivider"
           class="line-horizontal spacing-1">
      </div>

      <b-row :id="`${tooltipId} BodyText`"
             class="spacing-2">
        <b-col align="left">
          <span :class="bodyClass"
                v-html="bodyHTML">
          </span>
        </b-col>
      </b-row>

      <b-row class="spacing-3">
        <b-col>
          <b-button id="toolTipCloseButton"
                    :class="buttonClass"
                    @click="onClose">
            {{ toolTipButtonText }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </base-modal>
</template>

<script>
// Elements
import BaseModal from './BaseModal.vue'
import InlineSvg from './InlineSvg.vue'

// Utilities
import isEmpty from '../../../utility/isEmpty'

export default {
  name: 'tooltip',

  components: {
    BaseModal,
    InlineSvg
  },

  props: {
    buttonText: String,
    bodyHTML: String,
    headerText: String,
    isAlert: Boolean,
    showTooltip: Boolean,

    bodyClass: {
      type: String,
      default: 'text-14'
    },

    buttonClass: {
      type: String,
      default: 'button--primary'
    },

    displayAlertIcon: {
      type: Boolean,
      default: true
    },

    headerDivider: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tooltipId () {
      return this.headerText === undefined ? 'blankTooltip' : this.headerText.split(' ')[0] + 'Tooltip'
    },

    toolTipButtonText () {
      return isEmpty(this.buttonText) ? this.$t('global.close') : this.buttonText
    }
  },

  watch: {
    /**
     * Passing all props, attributes, and listeners down to a child component does not allow v-model to work properly so having to use a watcher to open/close base-modal instead.
     */
    showTooltip (value) {
      setTimeout(() => {
        if (value === true) {
          this.$bvModal.show(this.tooltipId)
        } else {
          this.$bvModal.hide(this.tooltipId)
        }
      }, 100)
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.icon--red {
  max-width: 1.688rem;
  max-height: 1.688rem;
  margin-top: auto;
  margin-right: 0.5rem;
  margin-bottom: auto;
}

.icon-with-text-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  margin-bottom: 0;
  line-height: 2rem;
}

.row--no-wrap {
  white-space: nowrap;
}
</style>
